import * as React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CustomInputText from './CustomInputText';

export interface CustomAutocompleteProps {
  label?: React.ReactNode;
  name?: string;
  options: any[];
  value?: any;
  onChange?: (event: React.SyntheticEvent, value: any) => void;
  getOptionLabel?: (option: any) => string;
  getOptionSelected?: (option: any, value: any) => boolean;
  placeholder?: string;
  disabled?: boolean;
  validators?: any[];
  errorMessages?: any[];
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  [key: string]: any;
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    boxShadow: 'rgb(145 158 171 / 30%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px',
    fontFamily: 'Montserrat'
  },
  option: {
    fontSize: '0.875rem',
    fontFamily: 'Montserrat',
    '&[data-focus="true"]': { backgroundColor: theme.palette.grey[100] },
    '&[aria-selected="true"]': { backgroundColor: '#EBF9FA' },
    '&[aria-selected="true"][data-focus="true"]': { backgroundColor: '#E1F4F5' }
  },
  // Neutralize the Autocomplete's own padding so the selected value aligns with the label (14px)
  // and is vertically centered like a plain input (idem ClientApp2).
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"]': { padding: '0 39px 0 14px !important' },
    '&[class*="MuiOutlinedInput-root"] [class*="MuiAutocomplete-input"]': {
      padding: '12px 0 !important'
    }
  }
}));

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
  label,
  name,
  options,
  value,
  onChange,
  getOptionLabel,
  placeholder,
  disabled,
  validators,
  errorMessages,
  fullWidth = true,
  ...rest
}) => {
  const classes = useStyles();
  const textValue = value == null ? '' : getOptionLabel ? getOptionLabel(value) : String(value);

  return (
    <Autocomplete
      classes={{ paper: classes.paper, option: classes.option, inputRoot: classes.inputRoot }}
      options={options}
      getOptionLabel={getOptionLabel}
      value={value ?? null}
      onChange={onChange as any}
      disabled={disabled}
      fullWidth={fullWidth}
      {...rest}
      renderInput={(params) => (
        <CustomInputText
          {...params}
          name={name}
          value={validators ? textValue : undefined}
          label={label}
          placeholder={placeholder}
          validators={validators}
          errorMessages={errorMessages}
          fullWidth={fullWidth}
          style={{ marginBottom: 0 }}
          InputProps={{
            ...params.InputProps,
            style: {
              height: '44.15px',
              minHeight: '44.15px',
              alignItems: 'center',
              ...(params.InputProps && (params.InputProps as any).style)
            }
          }}
        />
      )}
    />
  );
};

export default CustomAutocomplete;
